import { render } from "./index.vue?vue&type=template&id=5e0b04ec&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5e0b04ec&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-5e0b04ec"

export default script